import SolarPowerRoundedIcon from '@mui/icons-material/SolarPowerRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import LocalFireDepartmentRoundedIcon from '@mui/icons-material/LocalFireDepartmentRounded';
import WaterDropRoundedIcon from '@mui/icons-material/WaterDropRounded';
import { Box, Tooltip } from '@mui/material';
import CircleRoundedIcon from '@mui/icons-material/CircleRounded';
import { useTranslation } from 'react-i18next';

const TypeIcon = ({ params }) => {
  const { t } = useTranslation('portfolio-analysis');
  if (params.rowNode.isAutoGenerated && params.rowNode?.children?.length > 0) {
    let types = {};
    params.rowNode.children.forEach((childId) => {
      const child = params.api.getRow(childId);
      types[child.type] = true;
    });

    return (
      <Tooltip placement="left" title={t('type_descriptions.matrikel')}>
        <Box
          position="relative"
          display="flex"
          height={'100%'}
          alignContent={'center'}
        >
          <EnergyBadgedIcon types={types} />
        </Box>
      </Tooltip>
    );
  }
  const icon = (() => {
    if (params.row.type === 'power') {
      if (params.row.type_of_mp == 'D05') {
        return (
          <Tooltip placement="left" title={t('type_descriptions.solar_panel')}>
            <SolarPowerRoundedIcon
              sx={{ color: (theme) => theme.palette[params.row.type].main }}
            />
          </Tooltip>
        );
      } else {
        return (
          <Tooltip placement="left" title={t('type_descriptions.power')}>
            <BoltRoundedIcon
              sx={{ color: (theme) => theme.palette[params.row.type].main }}
            />
          </Tooltip>
        );
      }
    }

    if (params.row.type === 'water') {
      return (
        <Tooltip placement="left" title={t('type_descriptions.water')}>
          <WaterDropRoundedIcon
            sx={{ color: (theme) => theme.palette[params.row.type].main }}
          />
        </Tooltip>
      );
    }

    if (params.row.type === 'heat') {
      return (
        <Tooltip placement="left" title={t('type_descriptions.heat')}>
          <LocalFireDepartmentRoundedIcon
            sx={{ color: (theme) => theme.palette[params.row.type].main }}
          />
        </Tooltip>
      );
    }
  })();
  return (
    <Box display="flex" alignItems="center" width="100%" height="100%">
      {icon}
    </Box>
  );
};
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
const EnergyBadgedIcon = ({ types }) => {
  const SIZE = 11;
  const HEIGHT = 15;
  return (
    <>
      <ApartmentRoundedIcon
        sx={{ color: 'divider', my: 'auto', mx: 'auto' }}
        fontSize="medium"
      />

      {types?.power && (
        <CircleRoundedIcon
          sx={{
            position: 'absolute',
            top: HEIGHT,
            left: 0,
            fontSize: SIZE,
            color: (theme) => theme.palette.power.main,
          }}
        />
      )}
      {types?.water && (
        <CircleRoundedIcon
          sx={{
            position: 'absolute',
            top: HEIGHT,
            left: '50%',
            transform: 'translateX(-50%)',
            fontSize: SIZE,
            color: (theme) => theme.palette.water.main,
          }}
        />
      )}
      {types?.heat && (
        <CircleRoundedIcon
          sx={{
            position: 'absolute',
            top: HEIGHT,
            right: 0,
            fontSize: SIZE,
            color: (theme) => theme.palette.heat.main,
          }}
        />
      )}
    </>
  );
};

export default TypeIcon;
